<div class="overview" *ngIf="!loading; else trainingLoading">
  @if (!programme.modules?.length) {
    <div style="padding: var(--space-2xl) 0; text-align: center; color: var(--gray-500);">
      {{ 'Training_Learner.Not_Assigned' | translate }}
    </div>
  } @else {
    <div class="overview__header">
      <h3 class="overview__title">{{ programme.title }}</h3>
      <div class="overview__summary">
        <div class="overview__progress-info">
          <div class="overview__progress-text">
            <span style="font-weight: 600;">{{ 'Training_Learner.Overall_Progress' | translate }}</span>
            <span style="font-weight: 700; color: var(--brand-primary);">{{ trainingProgressService.overallProgress() }}%</span>
          </div>
          <div class="progress-bar progress-bar--large">
            <div class="progress-bar__fill" [style.width.%]="trainingProgressService.overallProgress()"></div>
          </div>
        </div>
        <div class="overview__stats">
          <div class="overview__stat">
            <div class="overview__stat-value">{{ trainingProgressService.completedCount() }}/{{ programme.modules.length }}</div>
            <div class="overview__stat-label">{{ 'Training_Learner.Modules_Passed' | translate }}</div>
          </div>
          <div class="overview__stat">
            <div class="overview__stat-value">{{ trainingProgressService.averageScore() > 0 ? trainingProgressService.averageScore() + '%' : '\u2014' }}</div>
            <div class="overview__stat-label">{{ 'Training_Learner.Average_Score' | translate }}</div>
          </div>
        </div>
      </div>
    </div>

  <!-- Certificate Banner -->
  <div class="overview__certificate-banner" [class.overview__certificate-banner--locked]="!trainingProgressService.certificateUnlocked()">
    <div class="certificate-banner__text">
      <h3>{{ trainingProgressService.certificateUnlocked() ? ('Training_Learner.Programme_Complete' | translate) : ('Training_Learner.Certificate_Locked' | translate) }}</h3>
      <p>
        @if (trainingProgressService.certificateUnlocked()) {
          {{ 'Training_Learner.Certificate_Unlocked_Message' | translate }}
        } @else {
          {{ ('Training_Learner.Certificate_Locked_Message' | translate)
            .replace('%s', programme.modules.length)
            .replace('%t', programme.modules.length - trainingProgressService.completedCount()) }}
        }
      </p>
    </div>
    @if (trainingProgressService.certificateUnlocked()) {
      <button class="btn btn--purple" (click)="navigate('/certificate')">
        <span [innerHTML]="Icons.trophy | safeHtml"></span> {{ 'Training.My_Training.View_Certificate' | translate }}
      </button>
    } @else {
      <span class="badge badge--not-started">
        <span [innerHTML]="Icons.lock | safeHtml"></span> {{ 'Training_Learner.Locked' | translate }}
      </span>
    }
  </div>

  <!-- Module Grid -->
  <div class="module-grid">
    @if (!programme.modules?.length) {
      <div style="padding: var(--space-xl) 0; text-align: center; color: var(--gray-500);">
        {{ 'Training_Learner.Not_Assigned' | translate }}
      </div>
    } @else {
      @for (mod of programme.modules; track mod.id; let i = $index) {
      <div class="card card--clickable module-card" (click)="navigate('/module/' + mod.id)">
        <div class="module-card__header">
          <span class="module-card__number">{{ ('Training_Learner.Module_Number' | translate).replace('%s', (i + 1)) }}</span>
          @switch (getModuleStatus(mod.id)) {
            @case ('not-started') {
              <span class="badge badge--not-started"><span class="badge__dot"></span>{{ 'Training_Learner.Not_Started' | translate }}</span>
            }
            @case ('in-progress') {
              <span class="badge badge--in-progress"><span class="badge__dot"></span>{{ 'Training_Learner.In_Progress' | translate }}</span>
            }
            @case ('passed') {
              <span class="badge badge--passed"><span class="badge__dot"></span>{{ 'Training_Learner.Passed' | translate }}</span>
            }
          }
        </div>
        <h4 class="module-card__title">{{ mod.title }}</h4>
        <p class="module-card__description">{{ mod.description }}</p>
        <div class="module-card__meta">
          <span><span [innerHTML]="Icons.clock | safeHtml"></span> {{ ('Training_Learner.Minutes_Label' | translate).replace('%s', mod.estimatedMinutes) }}</span>
          <span><span [innerHTML]="Icons.sections | safeHtml"></span> {{ ('Training_Learner.Sections_Label' | translate).replace('%s', mod.sections.length) }}</span>
        </div>
        @if (getModuleStatus(mod.id) !== 'not-started') {
          <div style="margin-bottom: var(--space-md);">
            <div class="progress-bar">
              <div class="progress-bar__fill" [style.width.%]="getProgressPercent(mod)"></div>
            </div>
          </div>
        }
        <div class="module-card__footer">
          <span style="font-size: 0.875rem; color: var(--gray-500);">
            @if (getModuleStatus(mod.id) === 'passed') {
              {{ 'Training_Learner.Score_Label' | translate }} <span style="font-weight:600; color: var(--green-primary);">{{ getModuleScore(mod.id) !== null ? (getModuleScore(mod.id)! * 100 | number:'1.0-0') + '%' : '' }}</span>
            } @else {
              {{ ('Training_Learner.Sections_Viewed' | translate).replace('%s', getViewedCount(mod.id)).replace('%t', mod.sections.length) }}
            }
          </span>
          <span style="color: var(--brand-primary); font-weight: 600; font-size: 0.875rem;">
            {{ getActionLabel(mod.id) | translate }} &rarr;
          </span>
        </div>
      </div>
      }
    }
  </div>
  }
</div>

<ng-template #trainingLoading>
  <div class="overview" style="min-height:200px; display:flex; align-items:center; justify-content:center;">
    <div class="spinner"></div>
  </div>
</ng-template>
